export const STOP_TESTS_HINT =
  "The check that is running finishes first; the ones after it are skipped.";
